// extracted by mini-css-extract-plugin
export default {"upload":"part_upload__vRVjm","table":"part_table__yfgos","modal":"part_modal__olXD0","search":"part_search__DEWQp","select":"part_select__E2J2y"};